import { render, staticRenderFns } from "./EditPrograms.vue?vue&type=template&id=e1493474"
import script from "./EditPrograms.vue?vue&type=script&lang=js"
export * from "./EditPrograms.vue?vue&type=script&lang=js"
import style0 from "./EditPrograms.vue?vue&type=style&index=0&id=e1493474&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports